//Imports
import React from "react";
import "./footer.css"

//Footer Component
function Footer() {
    return (
        <footer className="homeFooter"> </footer>
    )
}

//Exporting Footer component
export default Footer;
